

/**
 * Create a mapping of fields to their special sort columns:
 * {
 *   owner_name: ['owner_first_name', 'owner_last_name']
 * }
 *
 * @param {object} headers
 */
export default headers => {
  const sortByColumns = {};
  headers
    .filter(header => !!header.sortByColumns)
    .forEach(header => {
      sortByColumns[header.value] = header.sortByColumns;
    });
  return sortByColumns;
};
